// Palette
import palette from "../palette";

export default {
  root: {
    backgroundColor: palette.primary.light,
    color: "#fff",
    "& svg": {
      color: palette.primary.light
    },
    "&:hover": {
      backgroundColor: palette.primary.light
    },
  },
  colorPrimary: {
    border: `1px solid ${palette.primary.light}`,
  },
  deletable: {
    "&:focus": {
       backgroundColor: palette.background.light  
    }
  }, 
  outlined: {
    backgroundColor: palette.background.light,
    border: `1px solid ${palette.primary.light}`,
    color: palette.primary.main,
    "&:hover": {
      backgroundColor: palette.primary.light
    },
    "& svg": {
      color: palette.primary.light
    }
  }
};
